var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-chart',{ref:"chart",attrs:{"options":_vm.options,"auto-resize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }